import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { injectIntl } from "react-intl";
import Modal from "../Base/Modal/Modal";
import { useDelete } from "../Base/Hooks/delete";

const MasterVenueLinkRow = (props) => {
  const { itemIndex, result, pageRef, setRefreshFlag, intl, match, resources, sport } = props;
  const [deleteModalText, setDeleteModalText] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);

  const [refreshDeleteData, setRefreshDeleteData] = useState(false);
  const [masterVenueDeleteData, setmasterVenueDeleteData] = useState(null);
  const { deleteError, deleteLoading, deleteData } = useDelete(
    "/v1/" + sport + "/masterVenues/" + match.params.masterVenueId + "/venues/" + masterVenueDeleteData + "/linkages",
    "",
    refreshDeleteData,
  );
  const { formatMessage } = intl;

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
  useEffect(() => {
    if (deleteError) {
      pageRef.current.addFlash(
        formatMessage({
          id: "delete.failed",
          defaultMessage: "Delete Failed",
        }),
        +deleteError,
        "danger",
        10,
      );
    } else {
      if (deleteData) {
        pageRef.current.addFlash(
          formatMessage({
            id: "mastervenue.delete.success",
            defaultMessage: "Master Venue deleted successfully",
          }),
          "success",
          10,
        );
        setRefreshFlag(true);
      }
    }
    setRefreshDeleteData(false);
    setmasterVenueDeleteData(null);
    setRefreshDeleteData(false);
  }, [deleteData, deleteError, pageRef]);

  function showDeletemasterVenue(param) {
    setDeleteModalText(
      "You are about to delete link to " +
        resources.venues[result.organizationId + ":" + param.venueId].nameLocal +
        ". Is this OK?",
    );
    setDeleteModalOpen(true);
    setDeleteItemId(param.venueId);
  }

  function cancelModal() {
    setDeleteModalOpen(false);
  }

  function deletemasterVenue() {
    setmasterVenueDeleteData(deleteItemId);
    setRefreshDeleteData(true);
    setDeleteModalOpen(false);
  }

  return (
    <React.Fragment key={itemIndex}>
      <tr key={itemIndex} className={"deleting-" + deleteLoading}>
        <td>{resources.venues && resources.venues[result.venue.id].nameLocal}</td>
        <td>{resources.venues && resources.venues[result.venue.id].nameLatin}</td>
        <td>
          {resources.venues &&
            resources.venues[result.venue.id].address &&
            resources.venues[result.venue.id].address.city}
        </td>
        <td>{resources.venues && resources.venues[result.venue.id].countryCode}</td>
        <td>
          {resources.organizations && resources.organizations[result.organizationId].nameLocal}
          {"  "}
          <small>({result.organizationId})</small>
        </td>
        <td className="text-right controls-2">
          <Button outline color="danger" size="sm" onClick={(e) => showDeletemasterVenue(result, e)}>
            <i className="fas fa-minus" />
          </Button>
          <Modal
            isOpen={deleteModalOpen}
            heading="Delete Master Venue link?"
            text={deleteModalText}
            actionText={formatMessage({
              id: "delete",
              defaultMessage: "Delete",
            })}
            cancelText={formatMessage({
              id: "cancel",
              defaultMessage: "Cancel",
            })}
            action={deletemasterVenue}
            cancel={cancelModal}
          />
        </td>
      </tr>
    </React.Fragment>
  );
};

export default injectIntl(MasterVenueLinkRow);
